export default __webpack_public_path__ + "static/media/08-buy a new dress.93515f77.svg";